// src/routes/paths.ts
// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/login',
  DASHBOARD: '/web-twinprocms',
  PUBLIC: '/',
};

// ----------------------------------------------------------------------

export const paths = {
  page404: '/not-found',
  unauthorized: '/unauthorized',
  modal: '/modal',
  
  // PUBLIC / USER ROUTES
  public: {
    root: ROOTS.PUBLIC,
    sector: (slug: string) => `/sector/${slug}`,
    projects: '/projects',
    scene: (teleportationId: string) => `/scene/${teleportationId}`,
    unityScene: (id: string) => `/unity-scene/${id}`,
    privacyPolicy: '/privacy-policy',
    termsConditions: '/terms-conditions',
  },

  // RESOURCES / DOCUMENTATION (public, no auth)
  resources: {
    root: '/resources',
    interactive3d: '/resources/interactive-3d',
    arExperiences: '/resources/ar-experiences',
    tours360: '/resources/360-tours',
    accessControl: '/resources/access-control',
    publishControls: '/resources/publish-controls',
    instantUpdates: '/resources/instant-updates',
  },
  
  // AUTH ROUTES
  auth: {
    login: ROOTS.AUTH,
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
  },
  
  // ADMIN / CMS ROUTES
  admin: {
    root: ROOTS.DASHBOARD,
    dashboard: `${ROOTS.DASHBOARD}/dashboard`,
    scene: {
      root: `${ROOTS.DASHBOARD}/scene`,
      create: `${ROOTS.DASHBOARD}/scene/create`,
      update: (id: string) => `${ROOTS.DASHBOARD}/scene/${id}/update`,
    },
    interaction: {
      root: `${ROOTS.DASHBOARD}/interaction`,
      create: `${ROOTS.DASHBOARD}/interaction/create`,
      update: (id: string) => `${ROOTS.DASHBOARD}/interaction/update/${id}`,
    },
    categories: {
      root: `${ROOTS.DASHBOARD}/categories`,
      create: `${ROOTS.DASHBOARD}/categories/create`,
      update: (id: string) => `${ROOTS.DASHBOARD}/categories/${id}/update`,
    },
    categoryFilters: `${ROOTS.DASHBOARD}/category-filters`,
    productCategory: {
      root: `${ROOTS.DASHBOARD}/product-category`,
      create: `${ROOTS.DASHBOARD}/product-category/create`,
      update: (id: string) => `${ROOTS.DASHBOARD}/product-category/${id}/update`,
    },
    unityScene: {
      root: `${ROOTS.DASHBOARD}/unity-scene`,
      create: `${ROOTS.DASHBOARD}/unity-scene/create`,
      update: (id: string) => `${ROOTS.DASHBOARD}/unity-scene/${id}/update`,
    },
    webUrls: {
      root: `${ROOTS.DASHBOARD}/web-urls`,
      create: `${ROOTS.DASHBOARD}/web-urls/create`,
      update: (id: string) => `${ROOTS.DASHBOARD}/web-urls/${id}/update`,
      view: (id: string) => `${ROOTS.DASHBOARD}/web-urls/${id}/view`,
    },
    tours: {
      root: `${ROOTS.DASHBOARD}/360-tours`,
      create: `${ROOTS.DASHBOARD}/360-tours/create`,
    },
    products: {
      root: `${ROOTS.DASHBOARD}/products`,
      create: `${ROOTS.DASHBOARD}/products/create`,
      update: (id: string) => `${ROOTS.DASHBOARD}/products/${id}/update`,
    },
    users: {
      root: `${ROOTS.DASHBOARD}/users`,
      create: `${ROOTS.DASHBOARD}/users/create`,
      update: (id: string) => `${ROOTS.DASHBOARD}/users/${id}/update`,
    },
    audit: `${ROOTS.DASHBOARD}/audit`,
    fileLibrary: (id?: string) => id ? `${ROOTS.DASHBOARD}/file-library/${id}` : `${ROOTS.DASHBOARD}/file-library`,
    basicSettings: `${ROOTS.DASHBOARD}/basic-settings`,
    filters: `${ROOTS.DASHBOARD}/filters`,
    homepageOptions: `${ROOTS.DASHBOARD}/homepage-options`,
    shareIcon: `${ROOTS.DASHBOARD}/share-icon`,
    themeOptions: `${ROOTS.DASHBOARD}/theme-options`,
  },
};
